module.exports = __webpack_public_path__ + "static/media/download_android_app.d4355a3e.png";